import cn from 'classnames/bind';
import Image from 'next/image';
import Link from 'next/link';
import { Col, Container, Row } from 'ui';
import RoundedHeader from 'ui/layouts/RoundedHeader';
import { getAuthorHref } from 'utils/links';

import s from './SingleResourcesHeader.module.scss';

const cx = cn.bind(s);

const SingleResourcesHeader = ({ bgImage, title, author }) => (
  <RoundedHeader bgImage={bgImage} color={'mint'}>
    <Container className={cx('content')}>
      <Row>
        <Col
          sm={{
            offset: 0,
            span: 12,
          }}
          md={{
            offset: 1,
            span: 9,
          }}
          lg={{
            offset: 0,
            span: 7,
          }}
          xl={{
            offset: 1,
            span: 7,
          }}
        >
          <h1 className="tp-mobile-header-1 md:tp-tablet-header-1 xl:tp-header-1">
            {title}
          </h1>
          {author && (
            <div className="mt-8 group">
              <Link href={getAuthorHref(author.slug)}>
                <div className="flex gap-4 items-center">
                  <Image
                    src={author.image}
                    alt={`${author.name} photo`}
                    width={60}
                    height={60}
                    className="rounded-full max-w-full h-auto"
                  />
                  <div>
                    <h3 className="tp-header-3 group-hover:underline">{author.name}</h3>
                    <p className="text-[14px] leading-[20px]">{author.role}</p>
                  </div>
                </div>
              </Link>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  </RoundedHeader>
);

export default SingleResourcesHeader;
